export const AUTH_TOKEN_LS_KEY = 'adminAuthToken';

export const SCHOOL_EDUCATION = 'School Education';

// Regex for validations
// export const NAME_REGEX = /^[A-Za-z\s]{1,}[.]{0,1}[A-Za-z\s]{0,}$/;
export const NAME_REGEX = /^[a-zA-Z'-. ]+$/;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const NUMBER_REGEX = /^[0-9]*$/;
// export const LATITUDE_REGEX = /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/g;
// export const LONGITUDE_REGEX = /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/g;
export const LATITUDE_REGEX = /^(-?(?:180(?:\.0+)?|(?:1[0-7]\d|\d{1,2})\.\d{1,6}))$/;
export const LONGITUDE_REGEX = /^(-?(?:180(?:\.0+)?|(?:1[0-7]\d|\d{1,2})\.\d{1,6}))$/;

export const WEBSITE_REGEX = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;

export const DIGITS_REGEX = /[0-9]/;
// password regex
export const INCLUDES_UPPERCASE = /(?=.*?[A-Z])/;
export const INCLUDES_NUMBER = /(?=.*?[0-9])/;
export const INCLUDES_SYMBOL = /(?=.*?[#?!@$%^&*-])/;

export const POWERED_BY = 'Powered by SchoolMyKids';
export const BRAND_NAME = 'SchoolMyKids';
export const BRAND_TAG_LINE = '';

export const SortOrder = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const RADIX = 10;

export const isDevMode = process.env.REACT_APP_NODE_ENV !== 'production';
export const isProduction = process.env.REACT_APP_SCHOOLMYKIDS_API_URL === 'https://www.schoolmykids.com/api/v2';

export const COOKIE_OPTIONS = {
  path: '/',
  httpOnly: false,
  secure: !isDevMode,
  domain: process.env.REACT_APP_COOKIE_DOMAIN || undefined,
};
export const COOKIE_OPTIONS_SERVER_SIDE = {
  path: '/',
  httpOnly: true,
  secure: !isDevMode,
};
export const SMK_SESSION_COOKIE = 'smk_admin_session';
export const SMK_REFRESH_SESSION_COOKIE = 'smk_admin_refresh_session';
export const APP_SOURCE = 'app_source';
export const SMK_ACCESS_KEY = '_smk_access_key';
export const WEBSITE_ACCESS_TOKEN = 'mWTuQpm2rCl49XbQHOQq2MgouxudhGlbmTcgKwxLMtOoqyb7aqAxgjSO4DbeaVz3';

export const STAGING_API_URL = 'https://smkapi.rhatech.in/api/v2';

export const SMK_ANONYMOUS_COOKIE = 'smk_anonymous';

export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const API_BASE_URL = process.env.REACT_APP_SCHOOLMYKIDS_API_URL;

export const POST_STATUS = {
  DRAFT: 0,
  PENDING_FOR_APPROVAL: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const BABY_NAME_META_DATA_TYPE = {
  0: 'Gender',
  1: 'Nakshatra',
  2: 'Rashi',
  3: 'Religion',
  4: 'Origin',
  5: 'Meaning words',
};

export const POST_STATUS_STING = {
  0: 'Draft',
  1: 'Pending',
  2: 'Approved',
  3: 'Rejected',
};

export const TOPIC_STATUS = {
  PENDING_FOR_APPROVAL: 0,
  APPROVED: 1,
  REJECTED: 2,
};

export const TOPIC_STATUS_STING = {
  0: 'Pending',
  1: 'Approved',
  2: 'Rejected',
};

export const GENDER = {
  ALL_GENDER: 0,
  FEMALE: 1,
  MALE: 2,
  UNDISCLOSED: 3,
};
export const SCHOOL_GENDER_VALUES = {
  BOTH: 0,
  GIRLS: 1,
  BOYS: 2,
};
export const USER_GENDER = {
  Female: 1,
  Male: 2,
  UnDisclosed: 3,
};

export const GET_GENDER = {
  0: 'All Gender',
  1: 'Female',
  2: 'Male',
  3: 'Undisclosed',
};

export const MODULE_TYPE = {
  // NOT TO BE USED ------------------
  // GENERAL: 1,
  // ACTIVITY: 2,
  // STORY: 4,
  // REVIEWS: 6,
  // DIY: 10,
  RECIPE: 11, // ATTACHMENT
  // BABY_NAME_PRONUNCIATION: 12,
  // WORKSHEET_GENERATOR: 13,
  // CALCULATOR: 14,
  TPZ_APP: 15,
  // SMK_APP: 16,
  // DICTIONARY: 17,
  // SUBSCRIPTION: 20,
  // SMK_BLOG_ASSETS: 22,
  // TPZ_BLOG_ASSETS: 23,

  // COMMON ------------------
  ARTICLE: 3, // ASSET

  // app banner, taxonomy, solid food, forum cateogry, calculator, calculator category, subscription offer
  METADATA: 26, // ASSET

  FORUM: 5, // ATTACHMENT
  PROFILE: 21, // ATTACHMENT

  // SMK ------------------
  SCHOOL: 7, // ASSET
  COLLEGE: 25, // ASSET
  WORKSHEET: 8, // ATTACHMENT - should be ASSET

  WHITEBOARD: 24, // ATTACHMENT

  // TPZ ------------------
  BABY_NAMES: 9, // ASSET

  // TODO: once a threshold is reached move this to separate table and use UUID
  PATIENT_TRACKING: 18, // ATTACHMENT
  MEMORIES: 19, // ATTACHMENT
};

// export const MODULE_TYPE = {
//   GENERAL: 'general',
//   ACTIVITY: 'activity',
//   ARTICLE: 'article',
//   STORY: 'story',
//   FORUM: 'forum',
//   REVIEWS: 'reviews',
//   SCHOOL: 'school',
//   WORKSHEET: 'worksheet',
//   BABY_NAMES: 'baby_names',
//   DIY: 'diy',
//   RECIPE: 'recipe',
//   BABY_NAME_PRONUNCIATION: 'baby_name_pronunciation',
//   WORKSHEET_GENERATOR: 'worksheet_generator',
//   CALCULATOR: 'calculator',
//   TPZ_APP: 'tpz_app',
//   SMK_APP: 'smk_app',
//   DICTIONARY: 'dictionary',
//   BABY_TRACKING: 'baby_tracking',
//   MEMORIES: 'memories',
//   SUBSCRIPTION: 'subscription',
//   PROFILE: 'profile',
//   ASSETS: 'assets',
// };

export const GRADES = {
  Preschool: 1,
  Kindergarten: 2,
  First: 3,
  Second: 4,
  Third: 5,
  Fourth: 6,
  Fifth: 7,
  Sixth: 8,
  Seventh: 9,
  Eighth: 10,
};

export const DIFFICULTY_LEVEL = {
  Low: 1,
  Medium: 2,
  High: 3,
};

export const WORKSHEET_STATUS = {
  PENDING_FOR_APPROVAL: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const AGE_GROUP = {
  Infants: 1,
  Toddlers: 2,
  Kids: 3,
};

export const WORKSHEET_TYPE = {
  PRINTABLE_WORKSHEETS: 'printable_worksheets',
  WORKSHEET_GENERATOR: 'worksheet_generator',
  LIVE_WORKSHEETS: 'live_worksheets',
};

// export const AGE_GROUP = {
//   INFANTS: { value: 1, label: 'INFANTS' },
//   TODDLERS: { value: 2, label: 'TODDLERS' },
//   KIDS: { value: 3, label: 'KIDS' },
// };
export const USER_ROLE = {
  ADMIN: 0,
  STAFF: 1,
  USER: 2,
  ARTICLE_AUTHOR: 3,
  ARTICLE_REVIEWER: 4,
  SCHOOL_ADMIN: 5,
  ACTIVITY_ORGANIZER: 6,
  OFFLINE_USERS: 7,
  SMK_DOCTOR: 8,
};

export const GET_USER_ROLE = {
  0: 'ADMIN',
  1: 'STAFF',
  2: 'USER',
  3: 'ARTICLE_AUTHOR',
  4: 'ARTICLE_REVIEWER',
  5: 'SCHOOL_ADMIN',
  6: 'ACTIVITY_ORGANIZER',
  7: 'OFFLINE_USERS',
  8: 'SMK_DOCTOR',
};

export const GET_USER_SOURCE = {
  0: 'SIGNUP',
  1: 'SUBSCRIBE',
  2: 'ADMISSION_INQUIRY',
  3: 'ACTIVITY_INQUIRY',
  4: 'FORUM',
  5: 'COMMENTS',
  6: 'FACEBOOK',
  7: 'GOOGLE',
  8: 'DIGITAL_CAMPAIGN',
  9: 'OFFLINE_CAMPAIGN',
  10: 'REVIEW',
  11: 'CONTACT_INQUIRY',
  12: 'ADMIN',
  13: 'APPLE',
};

export const SCHOOL_REVIEWER_TYPE = {
  CURRENT_STUDENT: 1,
  RECENTLY_PASSED_STUDENT: 2,
  PARENT: 3,
  SCHOOL_ALUMNI: 4,
  SCHOOL_EMPLOYEE: 5,
  OTHERS: 6,
};

export const USER_SOURCE = {
  SIGNUP: 0,
  SUBSCRIBE: 1,
  ADMISSION_INQUIRY: 2,
  ACTIVITY_INQUIRY: 3,
  FORUM: 4,
  COMMENTS: 5,
  FACEBOOK: 6,
  GOOGLE: 7,
  DIGITAL_CAMPAIGN: 8,
  OFFLINE_CAMPAIGN: 9,
  REVIEW: 10,
  CONTACT_INQUIRY: 11,
  ADMIN: 12,
  APPLE: 13,
};

export const USER_STATUS = {
  INVITED: 0,
  ACTIVE: 1,
  DISABLED: 2,
};
export const GET_USER_STATUS = {
  0: 'Invited',
  1: 'Active',
  2: 'Disabled',
};

export const SchoolMasterType = {
  BOARDING_TYPE: 0,
  BOARDING_SUB_TYPE: 1,
  MANAGEMENT_TYPE: 2,
  INFRASTRUCTURE_FACILITIES_TYPE: 3,
  SCHOOL_CLUB: 4,
  LANGUAGE_OF_INSTRUCTION: 5,
  SCHOOL_RANKING_BODY: 6,
  SCHOOL_LEADERSHIP: 7,
  BOARDING_GENDER_TYPE: 8,
  DAYCARE_TYPE: 9,
};

export const PhoneNumberType = {
  LANDLINE: 'landline',
  MOBILE: 'mobile',
  TOLLFREE: 'toll-free',
};

export const EmailType = {
  INFO: 'info',
  ADMISSIONS: 'admissions',
};

export const BoardsType = {
  NATIONAL: 0,
  INTERNATIONAL: 1,
  BOTH: 2,
};

export const AdmissionContactPersonType = {
  ADMISSION_HEAD: 'Admission Head',
  ADMISSION_INCHARGE: 'Admission Incharge',
  ADMISSION_COUNSELLOR: 'Admission Counsellor',
  CONTACT_PERSON: 'Contact Person',
};

export const SchoolHolidaysType = {
  SUMMER: 'Summer',
  WINTER: 'Winter',
  AUTUMN: 'Autumn',
  HOLIDAYS: 'Holidays',
};

export const SeniorSecondaryStreams = [
  { name: 'Science with Mathematics' },
  { name: 'Science without Mathematics' },
  { name: 'Commerce' },
  { name: 'Humanities' },
  { name: 'Vocational Courses' },
  { name: 'General' },
];

export const SchoolShifts = [{ name: 'Shift 1 (Morning)' }, { name: 'Shift 2 (Afternoon)' }];

export const { PUBLIC_URL } = process.env;

export const PermissionEntityEnum_SMK = {
  MASTERDATA: 'masterdata',
  MEDIA: 'media',
  SITEMAP: 'sitemap',
  LOCATION: 'location',
  SMK_TAXONOMY: 'smk_taxonomy',

  USER: 'user',
  CONTACT_INQUIRY: 'contact_inquiry',

  SCHOOL: 'school',
  SCHOOL_REVIEW: 'school_review',
  SCHOOL_INQUIRY: 'school_inquiry',
  COLLEGE: 'college',

  WORKSHEET: 'worksheet',
  CALCULATOR: 'calculator',
  PTABLE: 'ptable',

  ACTIVITIES: 'activities',
  BLOG: 'blog',

  CMS: 'cms',
  ARTICLE: 'article',
  FORUMS: 'forums',

  // RECIPES
  NUTRITION_RECIPE: 'nutrition_recipe',
  NUTRITION_MEAL_PLAN: 'nutrition_meal_plan',
  NUTRITION_DIET_PLAN: 'nutrition_diet_plan',

  // COMMUNITY
  COMMUNITY_GROUP: 'community_group',
  COMMUNITY_POST: 'community_post',

  COMMUNITY_COMMENT: 'community_comment',
  COMMUNITY_USER: 'community_user',

  FITNESS_WORKOUT: 'fitness_workout',
  FITNESS_WORKOUT_PROGRAM: 'fitness_workout_program',
};
export const PermissionEntityEnum_TPZ = {
  MASTERDATA: 'masterdata',
  MEDIA: 'media',
  SITEMAP: 'sitemap',
  // LOCATION: 'location',

  USER: 'user',
  CONTACT_INQUIRY: 'contact_inquiry',

  TPZ_TAXONOMY: 'tpz_taxonomy',

  BABYNAME: 'babyname',
  BLOG: 'blog',

  CMS: 'cms',
  ARTICLE: 'article',
  FORUMS: 'forums',

  TPZ_APP: 'tpz_app',
  SEND_NOTIFICATION: 'send_notification',
  DOCTORS: 'doctors',
  MEDICINE: 'medicine',
  SOLID_FOODS: 'solid_foods',
  VACCINATION: 'vaccination',
  MILESTONE: 'milestone',
  APP_BANNER: 'app_banner',

  // RECIPES
  NUTRITION_RECIPE: 'nutrition_recipe',
  NUTRITION_MEAL_PLAN: 'nutrition_meal_plan',
  NUTRITION_DIET_PLAN: 'nutrition_diet_plan',

  // COMMUNITY
  COMMUNITY_GROUP: 'community_group',
  COMMUNITY_POST: 'community_post',

  COMMUNITY_COMMENT: 'community_comment',
  COMMUNITY_USER: 'community_user',

  FITNESS_WORKOUT: 'fitness_workout',
  FITNESS_WORKOUT_PROGRAM: 'fitness_workout_program',
};

export const PermissionEntityEnum_MEDIWATCHER = {
  MASTERDATA: 'masterdata',
  MEDIA: 'media',
  SITEMAP: 'sitemap',

  USER: 'user',
  CONTACT_INQUIRY: 'contact_inquiry',

  DOCTORS: 'doctors',
  MEDICINE: 'medicine',
  SOLID_FOODS: 'solid_foods',
  VACCINATION: 'vaccination',
  MILESTONE: 'milestone',
  APP_BANNER: 'app_banner',

  BLOG: 'blog',
  CMS: 'cms',
  ARTICLE: 'article',
  FORUMS: 'forums',

  // COMMUNITY
  COMMUNITY_GROUP: 'community_group',
  COMMUNITY_POST: 'community_post',

  COMMUNITY_COMMENT: 'community_comment',
  COMMUNITY_USER: 'community_user',

  FITNESS_WORKOUT: 'fitness_workout',
  FITNESS_WORKOUT_PROGRAM: 'fitness_workout_program',
};

export const SchoolReviewRejectReason = {
  INAPPROPRIATE: 'INAPPROPRIATE',
  MARKETING_CONTENT: 'MARKETING_CONTENT',
  DUPLICATE: 'DUPLICATE',
  REQUESTED_BY_SCHOOL: 'REQUESTED_BY_SCHOOL',
  REQUESTED_BY_REVIEWER: 'REQUESTED_BY_REVIEWER',
  OTHER: 'OTHER',
};

export const BabyNameMetaInfoType = {
  GENDER: 0,
  NAKSHATRA: 1,
  RASHI: 2,
  RELIGION: 3,
  ORIGIN: 4,
  MEANING_WORDS: 5,
};

export const BabyNameGenderValue = {
  0: 'Unisex',
  1: 'Girl',
  2: 'Boy',
};

export const BABY_NAME_TYPE = [
  {
    value: 0,
    label: 'Gender',
  },
  {
    value: 1,
    label: 'Nakshatra',
  },
  {
    value: 2,
    label: 'Rashi',
  },
  {
    value: 3,
    label: 'Religion',
  },
  {
    value: 4,
    label: 'Origin',
  },
  {
    value: 5,
    label: 'Meaning words',
  },
];

export const LANGUAGE_ARRAY_WITH_STRING = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'hi',
    label: 'Hindi',
  },
];

export const LANGUAGE_VALUES_STRING = {
  english: 'en',
  hindi: 'hi',
};
export const PRINT_LANGUAGE = {
  en: 'English',
  hi: 'Hindi',
};
export const PRINT_LANGUAGE_COLOR = {
  en: 'bg-info',
  hi: 'bg-warning',
};

export const GENDER_VALUES = {
  0: 'Unisex',
  1: 'Girl',
  2: 'Boy',
};

export const BABY_NAMES_GENDER_ARRAY = [
  {
    label: 'Unisex',
    value: 0,
  },
  {
    label: 'Girl',
    value: 1,
  },
  {
    label: 'Boy',
    value: 2,
  },
];

export const HINDI_BABY_NAMES_GENDER_ARRAY = [
  {
    label: 'उभयलिंगी',
    value: 0,
  },
  {
    label: 'लड़की',
    value: 1,
  },
  {
    label: 'लड़का',
    value: 2,
  },
];

export const GENDER_ARRAY = [
  {
    label: 'All Gender',
    value: 0,
  },
  {
    label: 'Female',
    value: 1,
  },
  {
    label: 'Male',
    value: 2,
  },
];
export const LIFESTYLE_ARRAY = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Sedentary',
    value: 'sedentary',
  },
];
export const USER_GENDER_ARRAY = [
  {
    label: 'All Gender',
    value: 0,
  },
  {
    label: 'Female',
    value: 1,
  },
  {
    label: 'Male',
    value: 2,
  },
  {
    label: 'UnDisclosed',
    value: 3,
  },
];

export const FEATURED_TYPE = {
  ZERO_LISTING: 'zero_listing',
  BANNER300: 'banner_300',
  BANNER720: 'banner_720',
  FEATURED_LISTING: 'featured_listing',
  SPONSORED_LISTING: 'sponsored_listing',
};

export const BANNER_TYPE = {
  PAGE_BANNER: 'PAGE_BANNER',
  POPUP_BANNER: 'POPUP_BANNER',
  TEXT_AD: 'TEXT_AD',
  BANNER_728: 'BANNER_728',
  BANNER_300: 'BANNER_300',
  FOOTER_BANNER: 'FOOTER_BANNER',
};

export const ACTIVE_AND_DELETED_ARRAY = [
  { value: null, label: 'All' },
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
export const YES_AND_NO_ARRAY = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const ACTION_TAKEN_ARRAY = [
  { value: -1, label: 'All' },
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const SORT_VALUES = {
  sortBy: 'id',
  sortOrder: -1,
};
export const SORT_VALUES_CREATED_DATE = {
  sortBy: 'createdDate',
  sortOrder: -1,
};
export const SORT_VALUES_DATE = {
  sortBy: 'updatedDate',
  sortOrder: -1,
};
export const SORT_VALUES_SLUG = {
  sortBy: 'slug',
  sortOrder: -1,
};

export const LOCATION_LEVEL_ARRAY = [
  {
    value: 0,
    label: 'Country',
  },
  {
    value: 1,
    label: 'Region',
  },
  {
    value: 2,
    label: 'District',
  },
  {
    value: 3,
    label: 'City / Metro',
  },
  {
    value: 4,
    label: 'Subarea/Locality',
  },
];

export const WEEK_DAYS = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};
export const CURRENCY_ARRAY = [
  { label: 'INR', value: 'inr' },
  { label: 'USD', value: 'usd' },
];

export const contactInquirySources = {
  GENERAL_INQUIRY: 0,
  EDITORIAL: 1,
  ADVERTISEMENT: 2,
  PUBLIC_RELATIONS: 3,
  SCHOOL_LISTINGS: 4,
  CAREEER: 5,
  TPZ_FEEDBACK: 10,
  TPZ_FEATURE_SUGGESTION: 11,
  TPZ_CUSTOMER_SUPPORT: 12,
  PARTNERSHIP: 13,
  CLAIM_PROFILE: 14,
};

export const createdByTypeSelect = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: 'Admin',
    value: USER_ROLE.ADMIN,
  },
  {
    label: 'Staff',
    value: USER_ROLE.STAFF,
  },
  {
    label: 'Other user',
    value: USER_ROLE.USER,
  },
];

export const achievementsType = {
  MILESTONE: 'milestone',
  CONSISTENCY: 'consistency',
  COMMUNITY: 'community',
  SPECIAL: 'special',
};
export const achievementsLevel = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum',
};

export const taxonomyType = {
  BABY_TRACKING_ACTIVITY_TYPE: 'baby_tracking_activity_type',
  PATIENT_TRACKING_ACTIVITY_TYPE: 'patient_tracking_activity_type',

  AGE_GROUP: 'age_group',

  MEDICINE_TYPE: 'medicine_type',
  MEDICINE_SYSTEM: 'medicine_system',
  MEDICINE_CLASSIFICATION: 'medicine_classification',

  MEDICAL_SYMPTOM: 'medical_symptom',
  TEETHING_SYMPTOM: 'teething_symptom',

  SOLID_FOOD_TYPE: 'solid_food_type',
  SOLID_FOOD_REACTION: 'solid_food_reaction',

  VACCINATION_COUNTRY: 'vaccination_country',
  VACCINATION_AGAINST: 'vaccination_against',

  MILESTONE_CATEGORY: 'milestone_category',

  CALCULATOR_CATEGORY: 'calculator_category',

  CHRONIC_DISEASES: 'chronic_diseases',

  // Recipe - urls are exposed tp frontend
  NUTRITION_MEAL_TYPE: 'nutrition_meal_type',
  NUTRITION_CUISINE: 'nutrition_cuisine',
  NUTRITION_DIETARY_PREFERENCE: 'nutrition_dietary_preference',

  NUTRITION_FOOD_ITEM_TYPE: 'nutrition_food_item_type',
  NUTRITION_MAIN_INGREDIENT: 'nutrition_main_ingredient',
  NUTRITION_COOKING_METHOD: 'nutrition_cooking_method',
  NUTRITION_OCCASION: 'nutrition_occasion',
  NUTRITION_SPECIAL_FEATURE: 'nutrition_special_feature',
  NUTRITION_OTHER_TAGS: 'nutrition_other_tags',
  NUTRITION_MEAL_TIME: 'nutrition_meal_time',

  // Recipe - urls are exposed tp frontend
  DOCTOR_SPECIALITY: 'doctor_speciality',

  MEDICAL_CONDITION_CHILDREN: 'medical_condition_children',
  MEDICAL_CONDITION_ADULT: 'medical_condition_adult',

  COMMUNITY_GROUP_CATEGORY: 'community_group_category',

  // VISION_DASHBOARD: 'vision_dashboard',

  // FITNESS TYPES
  FITNESS_MUSCLES: 'fitness_muscles',
  FITNESS_GOALS: 'fitness_goals',
  FITNESS_USE_CASES: 'fitness_use_cases',
  FITNESS_AVOID_IF: 'fitness_avoid_if',
  FITNESS_CONTRAINDICATIONS: 'fitness_contraindications',
  FITNESS_TAGS: 'fitness_tags',
};

export const medicineTypes = {
  ALLOPATHY: 'allopathy',
  HOMEOPATHY: 'homeopathy',
  UNANI: 'unani',
  AYURVEDIC: 'ayurvedic',
};
export const medicineStrengthUnits = {
  G: 'g',
  MG: 'mg',
  OZ: 'oz',
  ML: 'ml',
  FL_OZ: 'fl_oz',
  DROPS: 'drops',
  PCS: 'pcs',
  TSP: 'tsp',
  TBSP: 'tbsp',
};

export const SOURCE = [
  { label: 'SchoolMyKids', value: 'schoolmykids' },
  { label: 'The ParentZ', value: 'theparentz' },
  { label: 'Mediwatcher', value: 'mediwatcher' },
  { label: 'Period Tracker', value: 'periodtracker' },
];

export const appBannerSections = [
  { label: 'Full Page Banner', value: 'full_page' },
  { label: 'Popup Banner', value: 'popup_banner' },
  { label: 'Top Banner', value: 'top_banner' },
  { label: 'Mid Banner', value: 'mid_banner' },
  { label: 'Bottom Banner', value: 'bottom_banner' },
  { label: 'CTA Banner', value: 'cta_banner' },
  { label: 'Background Banner', value: 'background_banner' },
  { label: 'Patient Switcher Banner', value: 'patient_switcher' },
  { label: 'Adhoc Banner', value: 'adhoc_banner' },
];

export const sortBySearchData = [
  { label: 'ID', value: 'id' },
  { label: 'Name', value: 'name' },
  { label: 'Slug', value: 'slug' },
  { label: 'Create Date', value: 'createdDate' },
  { label: 'Age group', value: 'ageGroup' },
];

export const VaccinationUsualSiteArray = [
  {
    label: 'Thigh',
    value: 'thigh',
  },
  {
    label: 'Left thigh',
    value: 'left-thigh',
  },
  {
    label: 'By mouth',
    value: 'by-mouth',
  },
  {
    label: 'Upper arm/thigh',
    value: 'upper-arm-thigh',
  },
  {
    label: 'Both nostrils',
    value: 'both-nostrils',
  },
  {
    label: 'Upper arm',
    value: 'upper-arm',
  },
  {
    label: 'Left Upper arm',
    value: 'left-upper-arm',
  },
  {
    label: 'Right Upper arm',
    value: 'right-upper-arm',
  },
];

export const PAYMENT_INTERVAL = {
  monthly: 'monthly',
  yearly: 'yearly',
};

export const SUBSCRIPTION_MODULE_TYPE = {
  SCHOOL: 7,
  WORKSHEET: 8,
  BABY_TRACKING: 18,
  WHITEBOARD: 23,
};

export const NotificationActionEnum = {
  OPEN_APP: 'open_app',
  SHOW_POPUP: 'show_popup',
  TRIGGER_ADD_BUTTON_CLICK: 'trigger_add_button_click',
  OPEN_MODULE_ADD: 'open_module_add',
  OPEN_MODULE_EDIT: 'open_module_edit',
  OPEN_MODULE_DETAIL: 'open_module_details',
  OPEN_WEB_VIEW: 'open_web_view',
  OPEN_BROWSER: 'open_browser',
  TRIGGER_EMAIL_SEND: 'trigger_email_send',
  SHOW_MESSAGE_TEXT: 'show_message_text',
  SHOW_MESSAGE_HTML: 'show_message_html',
  TRIGGER_APP_REVIEW: 'trigger_app_review',
  TRIGGER_FEEDBACK: 'trigger_feedback',
  TRIGGER_POPUP: 'trigger_popup',
};
export const trigger_popup_payload_example = {
  text: '',
  html: '',
  image: {
    original: '',
  },
  primaryCTA: {
    text: 'OK',
    action: 'open_module_details',
    payload: {
      module: 'patient-tracking-activity',
      activityType: '',
      patientId: '',
    },
  },
  secondaryCTA: {
    text: 'Cancel',
    action: 'close_popup',
    payload: {},
  },
};

export const schoolAndCollegeImagesTypes = {
  logo: 'logo',
  banner: 'banner',
  featured: 'featured',
  image: 'image',
  // og_image: 'og_image',
};

export const DISCOUNT_TYPES = {
  PERCENTAGE: 'percentage',
  ABSOLUTE: 'absolute',
};
export const SUBSCRIPTION_STATUS_TYPES = {
  ALL: 'all',
  PAYMENT_PENDING: 'payment_pending',
  ACTIVE: 'active',
  EXPIRED: 'expired',
};

export const COLLEGE_GENDER_VALUES = {
  BOTH: 0,
  GIRLS: 1,
  BOYS: 2,
};

export const CollegeMasterType = {
  BOARDING_TYPE: 'boarding_type',
  BOARDING_SUB_TYPE: 'boarding_sub_type',
  MANAGEMENT_TYPE: 'management_type',
  INFRASTRUCTURE_FACILITIES_TYPE: 'infrastructure_facilities_type',
  LANGUAGE_OF_INSTRUCTION: 'language_of_instruction',
  RANKING_BODY: 'ranking_body',
  RECOGNIZING_BODY: 'recognizing_body',
  COURSE_LEVEL: 'course_level',
  COURSE_TYPE: 'course_type',
  COURSE_DEGREE: 'course_degree',
  COLLEGE_CLUB: 'college_club',
  BOARDING_GENDER_TYPE: 'boarding_gender_type',
};

export const CollegeMetaDataContentAttribute = {
  SUMMARY: 'summary',
  DESCRIPTION: 'description',
  CONTENT: 'content',
  ABOUT: 'about',
  ADMISSION: 'admission',
  FEE: 'fee',
  CURRICULAM: 'curriculam',
  CURRICULAR: 'curricular',
  SYLLABUS: 'syllabus',
};

export const PeriodTrackerBannerScreenEnum = {
  KEGEL_DASHBOARD: 'kegel_dashboard',
  BABY_DASHBOARD: 'baby_dashboard',
  MEDICINE_DASHBOARD: 'medicine_dashboard',
  MILESTONE_DASHBOARD: 'milestone_dashboard',
  VACCINATION_DASHBOARD: 'vaccination_dashboard',
  MORE: 'more',
  SUBSCRIPTION: 'subscription',
  USER_PROFILE: 'user_profile',
  REFER_A_FRIEND: 'refer_a_friend',
  BUY_SUBSCRIPTION: 'buy_subscription',
  MEMORIES: 'memories',
  CALENDAR_DASHBOARD: 'calendar_dashboard',
  RECIPE_DASHBOARD: 'recipe_dashboard',

  PATIENT_DASHBOARD: 'patient_dashboard',
  MEMORIES_DASHBOARD: 'memories_dashboard',
  RECIPE_SEARCH: 'recipe_search',
  RECIPE_DETAILS: 'recipe_details',

  ASK_AN_EXPERT: 'ask_an_expert',
  DOCUMENT_DASHBOARD: 'document_dashboard',

  ADD_DOCUMENT: 'add_document',
  APPOINTMENT_DASHBOARD: 'appointment_dashboard',
  EVENT_DASHBOARD: 'event_dashboard',
  ANALYTICS_DASHBOARD: 'analytics_dashboard',
  COMMUNITY_DASHBOARD: 'community_dashboard',
  MUSICLIBRARY_DASHBOARD: 'musiclibrary_dashboard',
  FOOD_DIET_DASHBOARD: 'food_diet_dashboard',
  FEEDING_DASHBOARD: 'feeding_dashboard',
  SLEEP_DASHBOARD: 'sleep_dashboard',
  DIAPER_DASHBOARD: 'diaper_dashboard',
  PUMPING_DASHBOARD: 'pumping_dashboard',
  GROWTH_DASHBOARD: 'growth_dashboard',
  TEMPERATURE_DASHBOARD: 'temperature_dashboard',
  TEETHING_DASHBOARD: 'teething_dashboard',
  SYMPTOMS_DASHBOARD: 'symptoms_dashboard',
  OTHER_ACTIVITY_DASHBOARD: 'other_activity_dashboard',

  BABY_SCHEDULE: 'baby_schedule',
  MEDICINE_DETAILS: 'medicine_details',

  BABY_NAMES_DASHBOARD: 'baby_names_dashboard',
  PARENTING_GUIDE_DASHBOARD: 'parenting_guide_dashboard',
  ROUTINE_DASHBOARD: 'routine_dashboard',
  VISION_DASHBOARD: 'vision_dashboard',
  REDEEM_GIFT_CARD: 'redeem_gift_card',
};

export const BannerScreenEnum = {
  BABY_DASHBOARD: 'baby_dashboard',
  MEDICINE_DASHBOARD: 'medicine_dashboard',
  MILESTONE_DASHBOARD: 'milestone_dashboard',
  VACCINATION_DASHBOARD: 'vaccination_dashboard',
  MORE: 'more',
  SUBSCRIPTION: 'subscription',
  USER_PROFILE: 'user_profile',
  REFER_A_FRIEND: 'refer_a_friend',
  BUY_SUBSCRIPTION: 'buy_subscription',
  MEMORIES: 'memories',
  CALENDAR_DASHBOARD: 'calendar_dashboard',
  RECIPE_DASHBOARD: 'recipe_dashboard',

  PATIENT_DASHBOARD: 'patient_dashboard',
  MEMORIES_DASHBOARD: 'memories_dashboard',
  RECIPE_SEARCH: 'recipe_search',
  RECIPE_DETAILS: 'recipe_details',

  ASK_AN_EXPERT: 'ask_an_expert',
  DOCUMENT_DASHBOARD: 'document_dashboard',

  ADD_DOCUMENT: 'add_document',
  APPOINTMENT_DASHBOARD: 'appointment_dashboard',
  EVENT_DASHBOARD: 'event_dashboard',
  ANALYTICS_DASHBOARD: 'analytics_dashboard',
  COMMUNITY_DASHBOARD: 'community_dashboard',
  MUSICLIBRARY_DASHBOARD: 'musiclibrary_dashboard',
  FOOD_DIET_DASHBOARD: 'food_diet_dashboard',
  FEEDING_DASHBOARD: 'feeding_dashboard',
  SLEEP_DASHBOARD: 'sleep_dashboard',
  DIAPER_DASHBOARD: 'diaper_dashboard',
  PUMPING_DASHBOARD: 'pumping_dashboard',
  GROWTH_DASHBOARD: 'growth_dashboard',
  TEMPERATURE_DASHBOARD: 'temperature_dashboard',
  TEETHING_DASHBOARD: 'teething_dashboard',
  SYMPTOMS_DASHBOARD: 'symptoms_dashboard',
  OTHER_ACTIVITY_DASHBOARD: 'other_activity_dashboard',

  BABY_SCHEDULE: 'baby_schedule',
  MEDICINE_DETAILS: 'medicine_details',

  BABY_NAMES_DASHBOARD: 'baby_names_dashboard',
  PARENTING_GUIDE_DASHBOARD: 'parenting_guide_dashboard',
  ROUTINE_DASHBOARD: 'routine_dashboard',
  VISION_DASHBOARD: 'vision_dashboard',
  REDEEM_GIFT_CARD: 'redeem_gift_card',
};

export const CollegeShifts = [{ name: 'Shift 1 (Morning)' }, { name: 'Shift 2 (Afternoon)' }];

export const AppSourceEnum = {
  SCHOOLYKIDS: 'schoolmykids',
  THEPARENTZ: 'theparentz',
  SUPERPETS: 'superpets',
  MEDIWATCHER: 'mediwatcher',
};

export const CollegeReviewRejectReason = {
  INAPPROPRIATE: 'INAPPROPRIATE',
  MARKETING_CONTENT: 'MARKETING_CONTENT',
  DUPLICATE: 'DUPLICATE',
  REQUESTED_BY_COLLEGE: 'REQUESTED_BY_COLLEGE',
  REQUESTED_BY_REVIEWER: 'REQUESTED_BY_REVIEWER',
  OTHER: 'OTHER',
};

export const COLLEGE_REVIEWER_TYPE = {
  CURRENT_STUDENT: 1,
  RECENTLY_PASSED_STUDENT: 2,
  PARENT: 3,
  COLLEGE_ALUMNI: 4,
  COLLEGE_EMPLOYEE: 5,
  OTHERS: 6,
};

export const COLLEGE_SEAT_CATEGORY = {
  UR: 'ur',
  'UR PwD': 'ur-pwd',
  'General EWS': 'general-ews',
  'General EWS PwD': 'general-ews-pwd',
  OBC: 'obc',
  'OBC PwD': 'obc-pwd',
  SC: 'sc',
  'SC PwD': 'sc-pwd',
  ST: 'st',
  'ST PwD': 'st-pwd',
};

export const COLLEGE_SEAT_TYPE = {
  All: 'all',
  'All India Quota': 'all-india-quota',
  'State Quota': 'state-quota',
  NRI: 'nri',
  MANAGEMENT: 'management',
  Others: 'others',
};

export const COLLEGE_FEE_TYPE = {
  'Total Fees': 'total-fees',
  'Admission Fee': 'admission-fee',
  'Tution Fee': 'tutorial-fee',
  'Registration Fee': 'registration-fee',
  'Hostel Fee': 'hostel-fee',
  'Examination Fee': 'examination-fee',
  'Other Fee': 'other-fee',
};

export const CURRENCY_TYPE = {
  INR: 'inr',
  USD: 'usd',
};

export const CURRENT_YEAR = new Date().getFullYear();

export const CollegeSeatSummaryType = [{ name: 'pgApproved' }, { name: 'ugApproved' }];

export const bloggerEmailsList = [
  'sumit.janu@rhatechnologies.com',
  'samridhi.rohatgi@rhatechnologies.com',
  'tanvi.munjal@rhatechnologies.com',
  'akanksha.priya@rhatechnologies.com',
  'sweeny.gupta@rhatechnologies.com',
];

export const STATIC_PAGE_SECTION_TYPES = [
  {
    label: 'Title Section',
    value: 'title_section',
  },
  {
    label: 'Subscribe Section',
    value: 'subscribe_section',
  },
  {
    label: 'Faq Section',
    value: 'faq_section',
  },
  {
    label: 'HowItWorks Section',
    value: 'howitworks_section',
  },
  {
    label: 'Reviews Section',
    value: 'review_section',
  },
  {
    label: 'CTA Section',
    value: 'cta_section',
  },
  {
    label: 'Featured Section',
    value: 'featured_section',
  },
  {
    label: 'Footer CTA Section',
    value: 'footer_cta_section',
  },
  {
    label: 'Custom Section 1',
    value: 'custom_section_1',
  },
  {
    label: 'Custom Section 2',
    value: 'custom_section_2',
  },
  {
    label: 'Custom Section 3',
    value: 'custom_section_3',
  },
  {
    label: 'Custom Section 4',
    value: 'custom_section_4',
  },
  {
    label: 'Custom Section 5',
    value: 'custom_section_5',
  },
  {
    label: 'Custom Section 6',
    value: 'custom_section_6',
  },
  {
    label: 'Custom Section 7',
    value: 'custom_section_7',
  },
  {
    label: 'Custom Section 8',
    value: 'custom_section_8',
  },
  {
    label: 'Custom Section 9',
    value: 'custom_section_9',
  },
  {
    label: 'Custom Section 10',
    value: 'custom_section_10',
  },
  {
    label: 'Custom Section 11',
    value: 'custom_section_11',
  },
  {
    label: 'Custom Section 12',
    value: 'custom_section_12',
  },
  {
    label: 'Custom Section 13',
    value: 'custom_section_13',
  },
  {
    label: 'Custom Section 14',
    value: 'custom_section_14',
  },
  {
    label: 'Custom Section 15',
    value: 'custom_section_15',
  },
  {
    label: 'Custom Section 16',
    value: 'custom_section_16',
  },
  {
    label: 'Custom Section 17',
    value: 'custom_section_17',
  },
  {
    label: 'Custom Section 18',
    value: 'custom_section_18',
  },
  {
    label: 'Custom Section 19',
    value: 'custom_section_19',
  },
  {
    label: 'Custom Section 20',
    value: 'custom_section_20',
  },
];

export const STATIC_PAGE_SECTION_TYPES_PERIODTRACKER_APP = [
  { label: 'Top Banner', value: 'top_banner' },

  { label: 'Content Block', value: 'content_block' },

  // for rendering single item
  { label: 'Single Item With Title', value: 'single_item_with_title' },
  { label: 'Single Item Without Title', value: 'single_item_no_title' },
  { label: 'Single Item Without Title Full Width', value: 'single_item_no_title_full_width' },

  // for rendering carousel
  { label: 'Carousel With Title', value: 'carousel_with_title' },
  { label: 'Carousel Without Title', value: 'carousel_no_title' },
  { label: 'Category Articles Carousel', value: 'category_articles' },

  // related to articles
  { label: 'Popular', value: 'popular' },
  { label: 'Recent', value: 'recent' },
  { label: 'Category List', value: 'category_list' },

  // generic
  { label: 'Quick Tips', value: 'quick_tips' },
  { label: 'Myths & Facts', value: 'myths_facts' },
  { label: 'Polls', value: 'polls' },
  { label: 'Quiz', value: 'quiz' },
  { label: 'FAQ', value: 'faq' },
  { label: 'Footer CTA Section', value: 'footer_cta_section' },
  { label: 'Community Block', value: 'community_block' },
  { label: 'AI Sakhi', value: 'ai_sakhi' },
  { label: 'AI Sakhi with Prompt', value: 'ai_sakhi_with_prompt' },

  // period tracker related
  { label: 'Cycle Graph', value: 'cycle_graph' },
  { label: 'PCOS Block', value: 'pcos_block' },
  { label: 'Possible Symptoms', value: 'possible_symptoms' },
  { label: 'Conception Block', value: 'conception_block' },
  { label: 'Current Cycle', value: 'current_cycle' },

  //
  { label: 'Recipe Block', value: 'recipe_block' },
  { label: 'Workout Block', value: 'workout_block' },

  // missed periods
  { label: 'Period Delay Survey', value: 'missed_period_survey' },

  // cycle day
  { label: 'Cycle Day: Cycle Info', value: 'cycle_day_cycle_info' },
  { label: 'Cycle Day: You Might Feel These', value: 'cycle_day_you_might_feel_these' },
  { label: 'Cycle Day: Discharge Pattern', value: 'cycle_day_discharge_pattern' },
  { label: 'Cycle Day: Hormone Highlights', value: 'cycle_day_hormone_highlights' },

  // home page
  { label: 'Home: How Do You Feel Today Symptoms', value: 'home_how_do_you_feel_today_symptoms' },
  { label: 'Home: Symptoms', value: 'home_symptoms' },
  { label: 'Home: Discount Banner', value: 'home_discount_banner' },
  { label: 'Home: My Medications', value: 'home_my_medications' },
  {
    label: 'Home: Ask an Expert Appointment Medicine Document',
    value: 'home_ask_expert_appointment_medicine_document',
  },
  { label: 'Home: Recipes', value: 'home_recipes' },
  { label: 'Home: Other Tools', value: 'home_other_tools' },
  { label: 'Home: Hormones Level', value: 'home_hormones_level' },
  { label: 'Home: Cycle History', value: 'home_cycle_history' },
  { label: 'Home: Symptoms Pattern', value: 'home_symptoms_pattern' },

  // // DUPLICATE - content_block
  // { label: 'Doctor Visit Alert', value: 'doctor_visit_alert' },
  // // DUPLICATE - content_block
  // { label: 'Self Care During Missed Periods', value: 'missed_period_self_care' },
  // // DUPLICATE - content_block
  // { label: 'Movement & Rest', value: 'movement_rest' },
  // // DUPLICATE - content_block
  // { label: 'Nutrition Tips', value: 'nutrition_tips' },
  // // DUPLICATE - carousel_no_title
  // { label: 'Articles List', value: 'articles_List' },
  // // DUPLICATE - single_item_no_title
  // { label: 'Podcast', value: 'podcast' },
  // // DUPLICATE - single_item_no_title
  // { label: 'Explanation', value: 'explanation' },
  // // DUPLICATE - articles_block
  // { label: 'Resources', value: 'resources' },
  // // DUPLICATE - single_item_no_title_full_width
  // { label: 'Join Community', value: 'join_community' },
  // // DUPLICATE - single_item_with_title
  // { label: 'Kegel Exercise', value: 'kegel_exercise' },
  // // DUPLICATE - single_item_no_title
  // { label: 'Breast Self Exam', value: 'breast_self_exam' },
  // // DUPLICATE - content_block
  // { label: 'When to Pay Attention', value: 'when_to_pay_attention' },
  // // DUPLICATE - content_block
  // { label: 'Cervical Mucus Pattern', value: 'cervical_mucus_pattern' },
  // // DUPLICATE - recipes_block
  // { label: 'Cycle-Based Recipes and Snacks', value: 'cycle_based_recipes_and_snacks' },
];

// export const FAQ_MODULES_SUB_MODULES = [
//   {
//     name: 'Static Pages',
//     slug: 'static-pages',
//     submodules: [
//       {
//         name: 'Contact Us',
//         slug: 'contact-us',
//       },
//       {
//         name: 'Guest Blogging',
//         slug: 'guest-blogging',
//       },
//       {
//         name: 'App',
//         slug: 'app',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//     ],
//   },
//   {
//     name: 'General Inquiry',
//     slug: 'general-inquiry',
//     submodules: [
//       {
//         name: 'Features',
//         slug: 'features',
//       },
//       {
//         name: 'Login',
//         slug: 'login',
//       },
//       {
//         name: 'Account',
//         slug: 'account',
//       },
//       {
//         name: 'Privacy & Security',
//         slug: 'privacy-security',
//       },
//       {
//         name: 'Ask TPZ',
//         slug: 'ask-tpz',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//     ],
//   },
//   {
//     name: 'Baby & Caregiver',
//     slug: 'baby-caregiver',
//     submodules: [
//       {
//         name: 'Baby',
//         slug: 'baby',
//       },
//       {
//         name: 'Caregiver',
//         slug: 'caregiver',
//       },
//       {
//         name: 'Family Access',
//         slug: 'family-access',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//     ],
//   },
//   {
//     name: 'Health Tracking',
//     slug: 'health-tracking',
//     submodules: [
//       {
//         name: 'Medicine',
//         slug: 'medicine',
//       },
//       {
//         name: 'Vaccination',
//         slug: 'vaccination',
//       },
//       {
//         name: 'Health Records',
//         slug: 'health-records',
//       },
//       {
//         name: 'Temperature',
//         slug: 'temperature',
//       },
//       {
//         name: 'Symptoms',
//         slug: 'symptoms',
//       },
//       {
//         name: 'Allergies',
//         slug: 'allergies',
//       },
//       {
//         name: 'Sleep',
//         slug: 'sleep',
//       },
//       {
//         name: 'Medical ID Cards',
//         slug: 'medical-id-cards',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//     ],
//   },
//   {
//     name: 'Growth & Development Tracking',
//     slug: 'growth-development-tracking',
//     submodules: [
//       {
//         name: 'Growth',
//         slug: 'growth',
//       },
//       {
//         name: 'Teething',
//         slug: 'teething',
//       },
//       {
//         name: 'Milestones',
//         slug: 'milestones',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//     ],
//   },
//   {
//     name: 'Activity Tracking',
//     slug: 'activity-tracking',
//     submodules: [
//       {
//         name: 'Feeding',
//         slug: 'feeding',
//       },
//       {
//         name: 'Solids',
//         slug: 'solids',
//       },
//       {
//         name: 'Bottle',
//         slug: 'bottle',
//       },
//       {
//         name: 'Nursing',
//         slug: 'nursing',
//       },
//       {
//         name: 'Sleep',
//         slug: 'sleep',
//       },
//       {
//         name: 'Diaper',
//         slug: 'diaper',
//       },
//       {
//         name: 'Pumping',
//         slug: 'pumping',
//       },
//       {
//         name: 'Crawling',
//         slug: 'crawling',
//       },
//       {
//         name: 'Bath Time',
//         slug: 'bath-time',
//       },
//       {
//         name: 'Story Time',
//         slug: 'story-time',
//       },
//       {
//         name: 'Tummy Time',
//         slug: 'tummy-time',
//       },
//       {
//         name: 'Play Time',
//         slug: 'play-time',
//       },
//       {
//         name: 'Screen Time',
//         slug: 'screen-time',
//       },
//       {
//         name: 'Outdoor Play',
//         slug: 'outdoor-play',
//       },
//       {
//         name: 'Indoor Play',
//         slug: 'indoor-play',
//       },
//       {
//         name: 'Diaper Change',
//         slug: 'diaper-change',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//     ],
//   },
//   {
//     name: 'Memories',
//     slug: 'memories',
//     submodules: [
//       {
//         name: 'Memories',
//         slug: 'memories',
//       },
//       {
//         name: 'Privacy & Security',
//         slug: 'privacy-security',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//     ],
//   },
//   {
//     name: 'Subscription & Payment',
//     slug: 'subscription-payment',
//     submodules: [
//       {
//         name: 'Subscriptions & Purchases',
//         slug: 'subscriptions-purchases',
//       },
//       {
//         name: 'Referral',
//         slug: 'referral',
//       },
//       {
//         name: 'Discount',
//         slug: 'discount',
//       },
//       {
//         name: 'Renewal',
//         slug: 'renewal',
//       },
//     ],
//     categories: [
//       {
//         name: 'General',
//         slug: 'general',
//       },
//       {
//         name: 'Upgrade to Premium',
//         slug: 'upgrade-to-premium',
//       },
//     ],
//   },
// ];

export const FAQ_MODULES_SUB_MODULES = [
  {
    name: 'Routine',
    submodules: ['Routine'],
    categories: ['General'],
  },
  {
    name: 'Static Pages',
    submodules: ['Contact Us', 'Guest Blogging', 'App'],
    categories: ['General'],
  },
  {
    name: 'General Inquiry',
    submodules: ['Features', 'Login', 'Account', 'Privacy & Security', 'Ask TPZ', 'Misha AI'],
    categories: ['General'],
  },
  {
    name: 'Baby & Caregiver',
    submodules: ['Baby', 'Caregiver', 'Family Access'],
    categories: ['General'],
  },
  {
    name: 'Health Tracking',
    submodules: [
      'Medicine',
      'Vaccination',
      'Health Records',
      'Temperature',
      'Symptoms',
      'Allergies',
      'Sleep',
      'Medical ID Cards',
    ],
    categories: ['General'],
  },
  {
    name: 'Growth & Development Tracking',
    submodules: ['Growth', 'Teething', 'Milestones'],
    categories: ['General'],
  },
  {
    name: 'Activity Tracking',
    submodules: [
      'Feeding',
      'Solids',
      'Bottle',
      'Nursing',
      'Sleep',
      'Diaper',
      'Pumping',
      'Crawling',
      'Bath Time',
      'Story Time',
      'Tummy Time',
      'Play Time',
      'Screen Time',
      'Outdoor Play',
      'Indoor Play',
      'Diaper Change',
      'Water Intake',
    ],
    categories: ['General'],
  },
  {
    name: 'Vision Prescription',
    submodules: ['Vision Prescription'],
    categories: ['General'],
  },
  {
    name: 'Memories',
    submodules: ['Memories', 'Privacy & Security'],
    categories: ['General'],
  },
  {
    name: 'Subscription & Payment',
    submodules: ['Subscriptions & Purchases', 'Referral', 'Discount', 'Renewal'],
    categories: ['General', 'Upgrade to Premium'],
  },
  {
    name: 'Ask Expert',
    submodules: ['Ask Expert'],
    categories: ['General'],
  },
];

export const SCHOOL_FAQ_CATEGORIES = [
  {
    category: 'Admissions',
    subcategories: ['Application Process', 'Eligibility Criteria', 'Important Dates', 'Fees & Scholarships'],
  },
  {
    category: 'Academics',
    subcategories: ['Curriculum', 'Class Schedule', 'Exams & Assessments', 'Homework & Assignments'],
  },
  {
    category: 'Campus Life',
    subcategories: ['Clubs & Activities', 'Sports', 'Events & Festivals', 'Student Support Services'],
  },
  {
    category: 'Policies & Rules',
    subcategories: ['Attendance Policy', 'Code of Conduct', 'Uniform Policy', 'Safety & Security'],
  },
  {
    category: 'Transportation',
    subcategories: ['Bus Routes', 'Pick-up & Drop-off', 'Parking Facilities', 'Transport Safety'],
  },
  {
    category: 'Parent & Teacher Communication',
    subcategories: ['Parent-Teacher Meetings', 'Progress Reports', 'Communication Channels', 'Feedback & Complaints'],
  },
];

export const APP_BANNER_EXAMPLE_PAYLOAD = [
  {
    action: 'open_module_details',
    payload: {
      module: 'string',
      screen: 'string',
      slug: 'string',
      babyId: 'string',
      childCategory: 'string',
      parentCategory: 'string',
      subscription: {
        offer_code: 'string',
      },
    },
  },
  {
    action: 'open_web_view',
    payload: {
      url: 'string',
    },
  },
  {
    action: 'open_module_add',
    payload: {
      module: 'string',
      activityType: 'string',
    },
  },
];

export const APP_BANNER_METADATA_EXAMPLES = {
  for_paid_user: true,
  festive_banner: true,
  countries: ['IN'],
  baby_name_color: '#ffffff',
  baby_age_opacity: 0.9,
  status_bar_theme: 'light',
  activity_icon_bg_color: '#ffffff',
  baby_switcher_bg_color: '#ffffff',
  activity_icon_bg_opacity: 0.2,
  baby_switcher_bg_opacity: 0.2,
  baby_switcher_icon_color: '#ffffff',
};

export const FIREBASE_JOB_APPLICATION_URL = 'https://rha-technologies-default-rtdb.firebaseio.com';

export const applicationStatus = [
  { label: 'Applied', value: 'applied' },
  { label: 'Under Review', value: 'under-review' },
  { label: 'Round One Interview', value: 'round-one-interview' },
  { label: 'Round Two Interview', value: 'round-two-interview' },
  { label: 'HR Round', value: 'hr-round' },
  { label: 'Hired', value: 'hired' },
  { label: 'Withdrawn', value: 'withdrawn' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Rejected Email Sent', value: 'rejected-email-sent' },
  { label: 'Rejected CV Not Relevant', value: 'rejected-cv-not-relevant' },
  { label: 'On Hold', value: 'on-hold' },
];

export const sourceValues = [
  { label: 'RHA Website', value: 'rha-website' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'Cut Short', value: 'cutshort' },
  { label: 'Naukri', value: 'naukri' },
  { label: 'Hirect', value: 'hirect' },
  { label: 'Referal', value: 'referal' },
  { label: 'Employee Referal', value: 'employee-referal' },
  { label: 'Others', value: 'others' },
];

export const admins_list = [
  'arun@rhatechnologies.com',
  'anil@rhatechnologies.com',
  'ankita.goyal@rhatechnologies.com',
  'arun.meena@gmail.com',
];

export const WORKSHEET_EMBED_SAMPLE_PAYLOAD = {
  componentName: 'additionMissingNumbersWorksheetGenerator',
  title: 'Addition Worksheet',
  displayNumber: false,
  showAnswers: false,
  numberOfProblems: 12,
  numberOfDigitsaddendOne: 1,
  numberOfDigitsaddendTwo: 1,
  regrouping: 'Yes',
  layout: 'vertical',
  maxaddendOne: 9,
  maxaddendTwo: 9,
  minaddendOne: 1,
  minaddendTwo: 1,
  worksheetType: 'addition',
};

export const shortToFullDay = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};

export const consultationStatusEnum = {
  REQUESTED: 'requested',
  SCHEDULED: 'scheduled',
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  CLOSED: 'closed',
  CANCELLED: 'cancelled',
};

export const FOOD_ITEM_REF_SOURCES = {
  IFCT: 'ifct',
  USDA: 'usda',
  CUSTOM: 'custom',
};

export const MEDICAL_ACTIVITIES = [
  { label: 'Temperature', value: 'temperature' },
  { label: 'Teething', value: 'teething' },
  { label: 'Symptoms', value: 'symptoms' },
  { label: 'Vaccination', value: 'vaccination' },
  { label: 'Vision', value: 'vision' },
  { label: 'Ask An Expert', value: 'ask-an-expert' },
  { label: 'Period Tracker', value: 'period-tracker' },
];

export const TPZ_CATEGORIES = [
  { label: 'Gastrointestinal (Digestive System)', value: 'gastrointestinal' },
  { label: 'Respiratory (Breathing-Related)', value: 'respiratory' },
  { label: 'General/Systemic', value: 'general-systemic' },
  { label: 'Skin-Related', value: 'skin-related' },
  { label: 'ENT (Ear, Nose, Throat) & Oral', value: 'ent-oral' },
  { label: 'Eye-Related', value: 'eye-related' },
];
export const TAXONOMY_METADATA_BOOLEANS = [
  { label: 'To Show on Recipe Homepage:', value: 'showOnHomePage' },
  { label: 'To Show on Recipe Selectearch bar category', value: 'showOnFilterCategory' },
  { label: 'has Details', value: 'hasDetails' },
  { label: 'has Expert Comments', value: 'hasExpertComments' },
];

export const MEAL_TIME = {
  BREAKFAST: 'breakfast',
  MORNING_SNACK: 'morning_snack',
  LUNCH: 'lunch',
  EVENING_SNACK: 'evening_snack',
  DINNER: 'dinner',
};
export const MEAL_TIME_UNITS = {
  Gram: 'gm',
};

export const FOOD_ITEM_GROUP = [
  { value: 'vegetable', label: 'Vegetable' },
  { value: 'fruit', label: 'Fruit' },
  { value: 'grain', label: 'Grain' },
  { value: 'dairy', label: 'Dairy' },
  { value: 'protein', label: 'Protein' },
  { value: 'legume', label: 'Legume' },
  { value: 'nut', label: 'Nut' },
  { value: 'fat_oil', label: 'Fat & Oil' },
  { value: 'beverage', label: 'Beverage' },
  { value: 'sweet', label: 'Sweet' },
  { value: 'seafood', label: 'Seafood' },
  { value: 'fungi', label: 'Fungi' },
  { value: 'herb_spice', label: 'Herb & Spice' },
  { value: 'misc', label: 'Miscellaneous' },
];

export const FOOD_ITEM_ORIGINS = [
  { value: 'plant_based', label: 'Plant based' },
  { value: 'animal_based', label: 'Animal based' },
  { value: 'synthetic', label: 'Synthetic' },
  { value: 'mixed', label: 'Mixed' },
  { value: 'fungal', label: 'Fungal' },
  { value: 'algae', label: 'Algae' },
];

export const FIRST_FOOD_DIETARY_TAGS = [
  'vegetarian',
  'vegan',
  'halal',
  'kosher',
  'gluten_free',
  'dairy_free',
  'nut_free',
  'peanut_free',
  'egg_free',
  'soy_free',
  'shellfish_free',
  'low_sugar',
  'low_sodium',
  'paleo',
  'keto',
  'organic',
  'non_gmo',
];

export const FIRST_FOOD_RELIGIOUS_AND_DIETARY = [
  {
    label: 'is Vegetarian',
    value: 'isVegetarian',
  },
  {
    label: 'is Halal',
    value: 'isHalal',
  },
  {
    label: 'is Kosher',
    value: 'isKosher',
  },
];

export const ARTICLE_TYPE_OPTIONS = [
  { label: 'Blog', value: 'blog' },
  { label: 'Video', value: 'video' },
  { label: 'Audio', value: 'audio' },
  // { label: 'Visual', value: 'visual' },
  // { label: 'Interactive', value: 'interactive' },

  { label: 'Slide show', value: 'slide_show' },
];

export const WEEK_DAY_OPTIONS = [
  { label: 'Monday', value: 'mon' },
  { label: 'Tuesday', value: 'tue' },
  { label: 'Wednesday', value: 'wed' },
  { label: 'Thursday', value: 'thur' },
  { label: 'Friday', value: 'fri' },
  { label: 'Saturday', value: 'sat' },
  { label: 'Sunday', value: 'sun' },
];

export const LOCKED_SECTION_TYPES_IN_PAGES = [];
